import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useCallback } from "react";

export const useFocusEditor = (): (() => void) => {
  const [editor] = useLexicalComposerContext();

  return useCallback(() => {
    editor.focus(() => {
      const { activeElement } = document;
      // oxlint-disable-next-line typescript/no-unsafe-type-assertion
      const rootElement = editor.getRootElement() as HTMLDivElement;
      if (
        rootElement !== null &&
        (activeElement === null || !rootElement.contains(activeElement))
      ) {
        rootElement.focus({ preventScroll: true });
      }
    });
  }, [editor]);
};
